// extracted by mini-css-extract-plugin
module.exports = {"switch":"SwitchTab__switch___2BJHc","text":"SwitchTab__text___43NyV","checkbox":"SwitchTab__checkbox___1LKK1","select":"SwitchTab__select___1y6Qc"};